import {
  Component,
  computed,
  input,
  output,
} from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { CoveragesGroup, Product } from '../../../Models/planes';
import { PipesModule } from '../../../pipes/pipes.module';

@Component({
  selector: 'sura-summary-plan-card',
  standalone: true,
  imports: [CommonModule, NgbModule, PipesModule, DatePipe],
  templateUrl: './summary-plan-card.component.html',
  styleUrls: ['./summary-plan-card.component.scss'],
})
export class SummaryPlanCardComponent {
  pagoPlan = input.required<Product | undefined>();
  disabledButton = input(false);
  isSummary = input<boolean>();
  valorAPagar = input.required<number>();
  valorMes = input.required<number>();
  tipoPago = input.required<string | undefined>();
  fecha = input.required<string>();
  cuidaCirculacion = input.required<string>();
  coveragesIncluded = input.required<CoveragesGroup[]>();
  vehicleDescription = input.required<string>();
  ownerFullName = input.required<string>();
  ownerDocument = input.required<string>();

  payClicked = output<'payment' | 'subscription'>();

  paymentFrequencyText = computed(() =>
    this.tipoPago() === 'Annually' ? 'Anual' : 'Mensual'
  );

  pagar(type: 'payment' | 'subscription'): void {
    this.payClicked.emit(type);
  }
}
